<template>
  <div class="footer">
    <div class="footer-inner clearfix">
      <div class="footer-inner-left">
        <img src="../assets/images/logo-dp-white@2x.png" alt />
        <p>The Better Airport Experience.</p>
      </div>
      <div class="footer-inner-right">
        <div v-text="$t('msg.footerPhone')"></div>
        <div>Email: info@dragonpass.com.cn</div>
        <div>Copyright @ DragonPass Company Limited</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "bottom"
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.footer {
  height: 140px;
  background: #333;
}
.footer-inner {
  width: 90%;
  height: 100%;
  margin: 0 auto;
  font-size: 14px;
  color: #fff;
}
.footer-inner-left {
  float: left;
  margin: 45px 0;
}
.footer-inner-left img {
  width: 168px;
  margin-bottom: 5px;
}
.footer-inner-right {
  float: right;
  margin: 30px 0;
}
.footer-inner-right div {
  margin-bottom: 10px;
}

.footer-inner-right div:last-child {
  margin-bottom: 0;
}

@media screen and (max-width: 640px) {
  .footer-inner-left {
    display: none;
  }
  .footer-inner-right {
    width: 100%;
    text-align: center;
    margin: 20px 0 0 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue